module.exports = __webpack_public_path__ + "img/bg-luky-primadani.f850547a.jpg";